import { deletePedido } from "@spark/services/pedidos";
import React, { useCallback } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Card, CardBody, CardTitle } from '@spark/ui-components/components/Card';
import Typography, { H3 } from '@spark/ui-components/components/Typography';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { useHistory, useParams } from 'react-router-dom';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import styled from 'styled-components';
import VagasProcessoEmAbertoCadastro from '../Cadastro/index';
import { notification } from '@spark/ui-components/utils/notification';

const BeneficiosDetalhes = () => {
  const history = useHistory();
  const { id } = useParams();

  const handleVoltar = useCallback(() => {
    history.goBack();
  }, [history]);

  const handleEditar = useCallback(() => {
    history.push(`/pages/beneficios/editar/${id}`);
  }, [history, id]);

  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'beneficios'
        }, {
          name: 'Detalhes'
        }]} />

        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <HeaderWrap>
                <CardTitle>
                  <H3>Detalhes da vaga</H3>
                </CardTitle>
                <ButtonContainer>
                  <ButtonWithLoading variant="outline-secondary" onClick={handleVoltar}>
                    Voltar
                  </ButtonWithLoading>
                  <ButtonWithLoading variant="primary" onClick={handleEditar}>
                    Editar
                  </ButtonWithLoading>
                </ButtonContainer>
              </HeaderWrap>
              <VagasProcessoEmAbertoCadastro isReadOnly={true} id={id} hideHeader={true} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>;
};

export default BeneficiosDetalhes;

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;
const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
